require('dotenv').config();

import Vue from 'vue'
import App from './App.vue'

import router from './router'

import store from './store'

import vuetify from './plugins/vuetify';
import '@mdi/font/css/materialdesignicons.css'

Vue.config.productionTip = false

Vue.use(require('vue-cookies'));

new Vue({
  router,
  store,
  vuetify,
  // apolloProvider,
  render: h => h(App)
}).$mount('#app')
